function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, $hooks, Array, JSON, Object, String, bookmarkDrawerOpen, bookmarks, editWarningModalOpen, reportDesc, reportDescTruncated, reportName, saveModalOpen) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const canWrite = $attr(`can-write`);;
    const canSave = $attr(`can-save`);;
    return {
      value: (h("div", {
        "class": {
          'mp-query-report-header': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-report-header-title': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: canSave && $helpers.editReportClicked
            },
            "class": Object.assign({}, {
              'unsaved-bookmark': !reportName,
              'editable-bookmark': canSave,
            }, {
              'mp-query-report-header-title-text': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(reportName || $attr(`empty-bookmark-name`));
            __jade_nodes = __jade_nodes.concat((canWrite) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": {
                  'disabled': !canSave,
                  'icon': `edit`,
                  'size': `small`,
                  'theme': `tertiary`,
                },
                "on": {
                  click: $helpers.editReportClicked
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined); /*  tooltip to explain disabled state */
            __jade_nodes = __jade_nodes.concat((!canSave && $attr(`save-disabled-tooltip`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "attrs": {
                  placement: `right`
                },
              }, [__vjadeSafeCode($attr(`save-disabled-tooltip`))]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          const computedAt = $attr(`computed-at`);;
          const samplingNotice = $helpers.getSamplingNotice();;
          const needsTruncation = reportDesc.length > 100;;
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-report-header-title-subtext': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((reportDesc) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  click: needsTruncation && $helpers.toggleDescriptionTruncation
                },
                "class": Object.assign({}, {
                  'mp-query-report-header-description-truncated': reportDescTruncated
                }, {
                  'mp-query-report-header-description': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-query-report-header-description-text': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(reportDesc);
                  __jade_nodes = __jade_nodes.concat((!reportDescTruncated) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "class": {
                        'mp-query-report-header-description-less': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("less");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat((needsTruncation && reportDescTruncated) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-query-report-header-description-more': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("more");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((computedAt || samplingNotice) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-query-report-header-title-subtext-separator': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(`·`);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((computedAt) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-last-updated", {
                "attrs": {
                  'is-compact': false,
                  'last-refresh-date': computedAt,
                  'preface-text': `Updated`,
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((samplingNotice) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'sampling-notice': true
                },
              }, [__vjadeSafeCode(samplingNotice)]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-report-header-actions': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-control-bar", {
            "attrs": $helpers.serializeAttributes({
              'theme': `tertiary`,
              'controls': $helpers.getHeaderActionItems(),
              'overflow-controls': $helpers.getHeaderActionOverflowItems(),
            }),
            "on": {
              select: $helpers.onHeaderActionClick
            },
          }, (function() {
            var __jade_nodes = []; /*  mirror item slots down the DOM tree */
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = ($helpers.getHeaderActionItemsSlots());
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("slot", {
                      "attrs": {
                        name: item.slot,
                        slot: item.slot
                      },
                    }));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var item = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("slot", {
                          "attrs": {
                            name: item.slot,
                            slot: item.slot
                          },
                        }));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean))); /*  saved reports drawer */
        __jade_nodes = __jade_nodes.concat((bookmarkDrawerOpen) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-bookmark-drawer", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, false)
            },
            "attrs": {
              'open': true,
              'delete-enabled': $attr(`can-write`),
              'loading': !bookmarks,
              'ootb-default-reports-enabled': $attr(`default-reports-enabled`),
              'saved-reports': JSON.stringify(bookmarks || []),
              'user-id': $attr(`user-id`),
            },
            "on": {
              close: $helpers.closeBookmarkDrawer,
              delete: $helpers.bookmarkDeleted,
              select: $helpers.bookmarkSelected,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        const isSavingNewReport = $helpers.isSavingNewReport();;
        const editWarning = $helpers.getEditWarning();; /*  TODO @evnp - replace modal jade with "promisified" modal code, e.g. https://github.com/mixpanel/analytics/blob/master/iron/common/widgets/chrome/chrome-header/index.ts#L759 */
        /*  save new report modal */
        __jade_nodes = __jade_nodes.concat(h("mp-create-entity-modal", {
          "hook": {
            remove: $hooks.delayedAttrRemove(`open`, false)
          },
          "attrs": {
            'open': saveModalOpen,
            'entity-type': `report`,
            'modal-title': `Save Report`,
            'initial-name': reportName || ``,
            'initial-description': reportDesc || ``,
            'initial-hidden': isSavingNewReport ? false : $attr(`selected-bookmark-hidden`),
            'initial-locked': isSavingNewReport ? false : $attr(`selected-bookmark-locked`),
            'hidden-disabled': isSavingNewReport ? false : !$attr(`can-save-hidden`),
            'lock-disabled': isSavingNewReport ? false : !$attr(`can-save-locked`),
            'warning': !isSavingNewReport && ($attr(`num-dashboards`) || $attr(`num-custom-alerts`)) ? editWarning : ``,
          },
          "on": {
            cancel: $helpers.closeSaveModal,
            save: $helpers.submitSaveModal,
          },
        })); /*  update existing report warning modal - warns when changes will affect dashboards or alerts */
        __jade_nodes = __jade_nodes.concat(h("mp-confirm", {
          "attrs": {
            theme: `confirm`,
            'confirm-button-label': 'Save',
            open: editWarningModalOpen,
          },
          "on": {
            submit: $helpers.editWarningModalSubmit,
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-confirm-title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Save report");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-confirm-description': true
              },
            }, [__vjadeSafeCode(editWarning)]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "bookmarkDrawerOpen" in locals ? locals.bookmarkDrawerOpen : typeof bookmarkDrawerOpen !== "undefined" ? bookmarkDrawerOpen : undefined, "bookmarks" in locals ? locals.bookmarks : typeof bookmarks !== "undefined" ? bookmarks : undefined, "editWarningModalOpen" in locals ? locals.editWarningModalOpen : typeof editWarningModalOpen !== "undefined" ? editWarningModalOpen : undefined, "reportDesc" in locals ? locals.reportDesc : typeof reportDesc !== "undefined" ? reportDesc : undefined, "reportDescTruncated" in locals ? locals.reportDescTruncated : typeof reportDescTruncated !== "undefined" ? reportDescTruncated : undefined, "reportName" in locals ? locals.reportName : typeof reportName !== "undefined" ? reportName : undefined, "saveModalOpen" in locals ? locals.saveModalOpen : typeof saveModalOpen !== "undefined" ? saveModalOpen : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;